/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var backendStatusLoaded = produce(function (draft, action) {
  var _draft$experimentId$w, _draft$experimentId, _draft$experimentId$t, _draft$experimentId2;
  var _action$payload = action.payload,
    experimentId = _action$payload.experimentId,
    status = _action$payload.status;
  draft[experimentId] = {
    status: status,
    loading: false,
    error: false,
    // Worker status comes from the socket, not this poll - reloading the pipeline status
    // must not wipe the message of a task that is still running.
    workerStatus: (_draft$experimentId$w = (_draft$experimentId = draft[experimentId]) === null || _draft$experimentId === void 0 ? void 0 : _draft$experimentId.workerStatus) !== null && _draft$experimentId$w !== void 0 ? _draft$experimentId$w : {},
    taskWorkers: (_draft$experimentId$t = (_draft$experimentId2 = draft[experimentId]) === null || _draft$experimentId2 === void 0 ? void 0 : _draft$experimentId2.taskWorkers) !== null && _draft$experimentId$t !== void 0 ? _draft$experimentId$t : {}
  };
}, initialState);
export default backendStatusLoaded;